let React;
const indexOf = [].indexOf ||
  function(item) {
    for (let i = 0, l = this.length; i < l; i++) {
      if (i in this && this[i] === item) return i;
    }
    return -1;
  };

React = require("react");

class Process_Button extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(nextProps) {
    let ref;
    if (
      nextProps.buttonState &&
      ((ref = nextProps.buttonState.toLowerCase()) === "success" ||
        ref === "failure")
    ) {
      return setTimeout(
        (_this => () => {
          if (typeof _this.props.resetState === "function") {
            return _this.props.resetState();
          }
        })(this),
        3000,
      );
    }
  }

  render() {
    let buttonClass;
    let colorClass;
    let extraClass;
    let iconButtonClass;
    let ref;
    let status;
    const colors = ["white", "green", "blue", "purple", "black"];
    if (this.props.buttonState) {
      status = this.props.buttonState.toLowerCase();
    } else {
      status = "initial";
    }
    colorClass = "";
    if ((ref = this.props.color, indexOf.call(colors, ref) >= 0)) {
      colorClass = this.props.color;
    }
    extraClass = "";
    if (this.props.extraClass) {
      extraClass = this.props.extraClass;
    }
    iconButtonClass = "";
    if (this.props.iconButton) {
      iconButtonClass = "button-icon";
    }
    buttonClass = [
      "button",
      "button-process",
      this.props.iconClass,
      iconButtonClass,
      colorClass,
      extraClass,
    ];
    if (
      status === "success" || status === "failure" || status === "processing"
    ) {
      buttonClass.push(status);
      if (this.props.iconButton) {
        buttonClass.splice(buttonClass.indexOf("button-icon"), 1);
      }
    }
    return (
      <div>
        <button
          onClick={this.props.callback}
          className={buttonClass.join(" ")}
          type="submit"
        >
          <span>{this.props.buttonText}</span>
        </button>
      </div>
    );
  }
}

export default Process_Button;
